import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function BtnsManger () {
    const { t } = useTranslation();
    return (
        <>
            <Link className="flex flex-center-center" to={'/products'}>
                <img alt="products" src={require("../../docs/light/box.png")} />
                <h6>{t("sections:products.label")}</h6>
            </Link>
            <Link className="flex flex-center-center" to={'/categories'}>
                <img alt="category" src={require("../../docs/light/tag.png")} />
                <h6>{t("sections:category.label")}</h6>
            </Link>
            <Link className="flex flex-center-center" to={'/investory'}>
                <img alt="investory" src={require("../../docs/light/warehouse.png")} />
                <h6>{t("sections:investory.label")}</h6>
            </Link>
            <Link className="flex flex-center-center" to={'/sales'}>
                <img alt="sales" src={require("../../docs/light/growth.png")} />
                <h6>{t("sections:sales.label")}</h6>
            </Link>
            <Link className="flex flex-center-center" to={'/employees'}>
                <img alt="HR" src={require("../../docs/light/user.png")} />
                <h6>{t("sections:HR.label")}</h6>
            </Link>
            <Link className="flex flex-center-center" to={'/crm'}>
                <img alt="HR" src={require("../../docs/light/CRM.png")} />
                <h6>{t("sections:CRM.label")}</h6>
            </Link>
            <Link className="flex flex-center-center" to={'/supplier'}>
                <img alt="supplier" src={require("../../docs/light/supplier.png")} />
                <h6>{t("sections:suppliers.label")}</h6>
            </Link>
        </>
    )
}